// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dummy-dashboard {
  animation: fadeIn 0.3s ease;
}

/* Welcome Banner */
.welcome-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 32px 36px;
  margin-bottom: 28px;
  color: white;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.35);
}

.welcome-text h2 {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 6px;
  color: white;
}

.welcome-text h2 span {
  color: #fde68a;
}

.welcome-text p {
  font-size: 14px;
  opacity: 0.85;
  margin-bottom: 12px;
}

.role-badge {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 13px;
  font-weight: 500;
  backdrop-filter: blur(4px);
}

.welcome-illustration {
  font-size: 80px;
  opacity: 0.25;
  color: white;
}

/* Stats Grid */
.dummy-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-bottom: 28px;
}

.dummy-stat-card {
  background: white;
  padding: 22px 24px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.dummy-stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
}

.dummy-stat-icon {
  width: 54px;
  height: 54px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: white;
  flex-shrink: 0;
}

.dummy-stat-icon.blue   { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
.dummy-stat-icon.green  { background: linear-gradient(135deg, #10b981 0%, #059669 100%); }
.dummy-stat-icon.orange { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); }
.dummy-stat-icon.red    { background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%); }

.dummy-stat-info h3 {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary, #1f2937);
  line-height: 1;
  margin-bottom: 4px;
}

.dummy-stat-info p {
  font-size: 13px;
  color: #6b7280;
}

/* Bottom grid */
.dummy-bottom-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.dummy-card {
  background: white;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
}

.dummy-card-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.dummy-card-title i {
  color: #667eea;
}

/* Quick Links */
.quick-links-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
}

.quick-link-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 10px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13px;
  color: #374151;
  font-weight: 500;
  transition: all 0.2s ease;
}

.quick-link-btn i {
  font-size: 22px;
  color: #667eea;
}

.quick-link-btn:hover {
  background: #667eea;
  color: white;
  border-color: #667eea;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.quick-link-btn:hover i {
  color: white;
}

/* Announcements */
.announcement-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.announcement-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f3f4f6;
}

.announcement-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.announcement-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  flex-shrink: 0;
}

.announcement-body p {
  font-size: 13px;
  color: #374151;
  margin-bottom: 3px;
  line-height: 1.5;
}

.announcement-body span {
  font-size: 11px;
  color: #9ca3af;
}

/* Schedule */
.schedule-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.schedule-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 14px;
  background: #f9fafb;
  border-radius: 8px;
  border-left: 3px solid #667eea;
}

.schedule-time {
  font-size: 12px;
  font-weight: 600;
  color: #667eea;
  min-width: 80px;
}

.schedule-desc {
  font-size: 13px;
  color: #374151;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (max-width: 640px) {
  .welcome-banner {
    padding: 24px 20px;
  }
  .welcome-illustration {
    display: none;
  }
  .welcome-text h2 {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DummyDashboard.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,0BAA0B,6DAA6D,EAAE;AACzF,0BAA0B,6DAA6D,EAAE;AACzF,0BAA0B,6DAA6D,EAAE;AACzF,0BAA0B,6DAA6D,EAAE;;AAEzF;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".dummy-dashboard {\n  animation: fadeIn 0.3s ease;\n}\n\n/* Welcome Banner */\n.welcome-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 16px;\n  padding: 32px 36px;\n  margin-bottom: 28px;\n  color: white;\n  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.35);\n}\n\n.welcome-text h2 {\n  font-size: 26px;\n  font-weight: 700;\n  margin-bottom: 6px;\n  color: white;\n}\n\n.welcome-text h2 span {\n  color: #fde68a;\n}\n\n.welcome-text p {\n  font-size: 14px;\n  opacity: 0.85;\n  margin-bottom: 12px;\n}\n\n.role-badge {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  border-radius: 20px;\n  padding: 4px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  backdrop-filter: blur(4px);\n}\n\n.welcome-illustration {\n  font-size: 80px;\n  opacity: 0.25;\n  color: white;\n}\n\n/* Stats Grid */\n.dummy-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n  margin-bottom: 28px;\n}\n\n.dummy-stat-card {\n  background: white;\n  padding: 22px 24px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.dummy-stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\n}\n\n.dummy-stat-icon {\n  width: 54px;\n  height: 54px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  color: white;\n  flex-shrink: 0;\n}\n\n.dummy-stat-icon.blue   { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }\n.dummy-stat-icon.green  { background: linear-gradient(135deg, #10b981 0%, #059669 100%); }\n.dummy-stat-icon.orange { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); }\n.dummy-stat-icon.red    { background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%); }\n\n.dummy-stat-info h3 {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--text-primary, #1f2937);\n  line-height: 1;\n  margin-bottom: 4px;\n}\n\n.dummy-stat-info p {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n/* Bottom grid */\n.dummy-bottom-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n}\n\n.dummy-card {\n  background: white;\n  border-radius: 14px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);\n}\n\n.dummy-card-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary, #1f2937);\n  margin-bottom: 18px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dummy-card-title i {\n  color: #667eea;\n}\n\n/* Quick Links */\n.quick-links-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 12px;\n}\n\n.quick-link-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 10px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #374151;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.quick-link-btn i {\n  font-size: 22px;\n  color: #667eea;\n}\n\n.quick-link-btn:hover {\n  background: #667eea;\n  color: white;\n  border-color: #667eea;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.quick-link-btn:hover i {\n  color: white;\n}\n\n/* Announcements */\n.announcement-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.announcement-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.announcement-item:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.announcement-icon {\n  width: 36px;\n  height: 36px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.announcement-body p {\n  font-size: 13px;\n  color: #374151;\n  margin-bottom: 3px;\n  line-height: 1.5;\n}\n\n.announcement-body span {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n/* Schedule */\n.schedule-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.schedule-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 14px;\n  background: #f9fafb;\n  border-radius: 8px;\n  border-left: 3px solid #667eea;\n}\n\n.schedule-time {\n  font-size: 12px;\n  font-weight: 600;\n  color: #667eea;\n  min-width: 80px;\n}\n\n.schedule-desc {\n  font-size: 13px;\n  color: #374151;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@media (max-width: 640px) {\n  .welcome-banner {\n    padding: 24px 20px;\n  }\n  .welcome-illustration {\n    display: none;\n  }\n  .welcome-text h2 {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
